import MenuViewMode from './MenuViewMode';
/*
import PhysicalCameraManager from '../../PhysicalCameraManager';
import MenuCameraManager from '../../MenuCameraManager';
import GeofenceManager from '../../GeofenceManager';
import TaglockMarkerManager from '../../TaglockMarkerManager';
import PlayerSettings from '../../PlayerSettings';
import CameraObjectManager from '../../CameraObjectManager';
import LprManager from '../../LprManager';
*/

// This represents the Recordings mode of the MenuView
/**
 * @class EventsMode
 * @description User is able to see events. Get activated when Events tab is clicked.
 * @function on_tab_selected() - Get called when user has clicked the tab. (called by MenuView).
 * @function on_player_hide() -  Get called when we want to hide the player. (called by PlayerContainer)
 * @function is_valid_camera() -  It works as filter for whcich camera to display in the menu view.Called by menuView.js
 * 
 */
export default class EventsMode extends MenuViewMode
{
  constructor()
  {
    super('events');
  }

  on_tab_selected(menu_view)
  {
    if (PhysicalCameraManager.selected_camera) PhysicalCameraManager.selected_camera.show_player_on_zoom = false;
    menu_view.fill_menu(0);
    GeofenceManager.hide_geofence();
    TaglockMarkerManager.remove_all_markers();
    LprManager.remove_object();
    PlayerSettings.set_events_mode();
    CameraObjectManager.set_events_mode();

    menu_view.app.recording_telemetry_controller.stop_streaming(PhysicalCameraManager.cameras[0]);
  }

  is_valid_camera(physical_camera)
  {
    return (physical_camera.bodyworn !== 'yes' && physical_camera.cam_type !== 'phone');
  }

  on_player_hide(player_container)
  {
    player_container.app.recording_telemetry_controller.stop_streaming(PhysicalCameraManager.selected_camera);
  }

  on_camera_selected(menu_view)
  {
    menu_view.show_calendar_view();

    menu_view.app.calendar_view.get_recordings_from_camera(PhysicalCameraManager.selected_camera);
    if (!app.mode_optimized)
    {
      menu_view.app.calendar_view.get_events_from_camera(PhysicalCameraManager.selected_camera);
    }
  }

  on_day_selected(app)
  {
    console.log('[on_day_selected]');
    // Recordings
    //let first_fragment = app.player_view.playback_bar.get_first_fragment();
    //app.player_view.play_recording(first_fragment);

    app.player_view.extract_recording_view.show_open_button();
    //app.player_container.show();
    //app.calendar_view.hide();
    //app.menu_view.hide_calendar_view();
    //app.menu_view.close();

    app.player_view.extract_recording_view.hide_open_button();

    // Reset menu index back to zero every time a new day is selected
    app.axis_event_manager.menu_index = 0;
    app.menu_view.show_events_list_view();

    // TODO: TEMP Disable for ADSB PhysicalCameraManager.selected_camera.fly_on_valid_telemetry = true;
    //PhysicalCameraManager.selected_camera.fly_on_valid_telemetry = true;
  }

  on_recording_played(player_view, fragment)
  {
    console.log('[EventsMode:on_recording_played]');

    player_view.app.recording_telemetry_controller.stop_streaming(PhysicalCameraManager.selected_camera);

    let camera = PhysicalCameraManager.selected_camera;
    
    // Set recording id and time to the selected setram
    camera.stream.set_recording_data(
      fragment.id,
      fragment.get_relative_offset_ms(player_view.playback_time) / 1000,
      fragment.recording.start_date
    );

    // Set Recording profle to the selected stream (rec_profile is variable that is loaded dynamically from camera settings)
    camera.stream.set_profile(PhysicalCameraManager.selected_camera.rec_profile);

    // player_view.play is passed as a callback, so the AxisCameraStream can call it
    // when the RTSP connection is ready to stream
    camera.stream.start_streaming(player_view.play.bind(player_view));

    player_view.app.axis_event_manager.show_events();

    //camera.fly_on_valid_telemetry = true;
    camera.fly_to_camera_marker();
  }
}
